{
  "expandControls": {
    "expand": "Expand",
    "collapse": "Collapse",
    "expandRecursively": "Expand Recursively",
    "collapseRecursively": "Collapse Recursively"
  }
}